import { Flex, Spacing, Text } from '@billy/design-system'
import { ElementType, ReactElement } from 'react'

import { getImageClassName } from '../../../../../../utils/getClassName'

interface EInvoicingGetStartedStepProps {
  title: string
  description: string
  illustration: ElementType
}

export const EInvoicingGetStartedStep = ({
  title,
  description,
  illustration: Illustration,
}: EInvoicingGetStartedStepProps): ReactElement => {
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" width="100%" gap={Spacing.S8}>
      <Illustration className={getImageClassName()} />
      <Text variant="h4" alignment="center">
        {title}
      </Text>
      <Text colorVariant="secondary" alignment="center">
        {description}
      </Text>
    </Flex>
  )
}
